module.exports = __webpack_public_path__ + "img/Battery Icon - charcoal.e04dbb1e.svg";